import { render, staticRenderFns } from "./certificateIssuingStudentList.vue?vue&type=template&id=51d08506&scoped=true"
import script from "./certificateIssuingStudentList.vue?vue&type=script&lang=js"
export * from "./certificateIssuingStudentList.vue?vue&type=script&lang=js"
import style0 from "./certificateIssuingStudentList.vue?vue&type=style&index=0&id=51d08506&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d08506",
  null
  
)

export default component.exports